export default "__VITE_ASSET__BaV1nE_1__"